<script>
import CardSections from "../Shared/CardSections.vue";
import TextInput from "../../../Shared/TextInput.vue";
import throttle from "lodash/throttle";
import axios from "axios";

export default {
    name: "Verify",
    components: { TextInput, CardSections },
    props: {
        errors: Object,
        email: String,
    },
    data() {
        return {
            form: this.$inertia.form({
                email: this.email,
                token: null,
            }),
            resend_token: {
                message: null,
                isError: false,
            },
            resendToken: throttle(() => this.handleResendToken(), 30000),
        }
    },
    methods: {
        submit() {
            this.form.post(
                this.route('nl.employerdashboard.settings.primary-email.verify.attempt', {
                    company_as_uuid: this.$page.props.auth.user.selected_company.uuid,
                })
            )
        },
        handleResendToken() {
            axios
                .post(
                    this.route('nl.employerdashboard.settings.primary-email.resend-token.attempt', {
                        company_as_uuid: this.$page.props.auth.user.selected_company.uuid,
                        email: this.email,
                    })
                )
                .then(response => {
                    this.resend_token.message = response.data.message
                    this.resend_token.isError = false;
                })
                .catch(err => {
                    this.resend_token.message = Lang.get('generic.something_went_wrong')
                    this.resend_token.isError = true;
                })
        },
    }
}
</script>

<template>
    <card-sections
        :title="Lang.get('employerdashboard::pages/settings/primary-email/edit.title')"
        :subtitle="Lang.get('employerdashboard::pages/settings/primary-email/edit.subtitle')"
        tabName="profile"
        :hideMsg="true"
    >
        <p>
            {{ Lang.get('employerdashboard::pages/settings/primary-email/verify.explanation') }}
        </p>
        <p>
            <span v-html="Lang.get('employerdashboard::pages/settings/primary-email/verify.instructions.before_link', {
                email,
            })" />
            <a href="#" @click='resendToken'>{{ Lang.get('employerdashboard::pages/settings/primary-email/verify.instructions.link') }}</a>
            <span> {{ Lang.get('employerdashboard::pages/settings/primary-email/verify.instructions.after_link') }}</span>
        </p>
        <form @submit.prevent="submit">
            <text-input
                class="w-75 mb-4"
                id="token"
                v-model="form.token"
                :label="Lang.get('employerdashboard::pages/settings/primary-email/verify.form.token.label')"
                :error="errors.token"
            />
            <div class="d-flex mt-4 align-items-center">
                <button type="submit" class="btn btn-primary mr-2" :disabled="form.processing">
                    {{ Lang.get('employerdashboard::pages/settings/primary-email/verify.submit') }}
                </button>
            </div>
        </form>
        <div class="my-3 p-2 rounded"
             :class="{ 'alert-danger' : resend_token.isError, 'alert-info' : !resend_token.isError }"
             v-show="resend_token.message">
            {{ resend_token.message }}
        </div>
    </card-sections>
</template>
